import React from 'react';
import type { SearchInputProps } from '../interfaces';

const SearchInput: React.FC<SearchInputProps> = ({
  inputOpen,
  inputRef,
  isSearchPanelOpen,
  hasInteracted,
  query,
  onQueryChange,
  onSearch,
}) => (
  <div className="container-search">
    <div className={`mainbox ${inputOpen ? 'open' : 'closed'}`}>
      <input
        ref={inputRef}
        className={`search_input ${inputOpen ? 'open' : 'closed'}`}
        type="text"
        placeholder={inputOpen ? 'Search jewelry' : ''}
        aria-label="Search jewelry catalog"
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
        onKeyDown={(event) => event.key === 'Enter' && onSearch()}
      />
      <button
        type="button"
        className="iconContainer"
        onClick={onSearch}
        aria-label={inputOpen ? 'Search catalog' : 'Open catalog search'}
        aria-controls="catalog-search-results"
        aria-expanded={isSearchPanelOpen}
      >
        <svg
          viewBox="0 0 512 512"
          height="1em"
          xmlns="http://www.w3.org/2000/svg"
          className={`search_icon ${inputOpen ? 'open' : 'closed'} ${hasInteracted ? 'can-animate' : ''}`}
          aria-hidden="true"
        >
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
        </svg>
      </button>
    </div>
  </div>
);

export default React.memo(SearchInput);
